import { clearActiveSellerGroupId } from '@seller-hermes/features/portal/portal-local-context';
import { Auth } from 'aws-amplify';
import { Loader2 } from 'lucide-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { publishLogoutMarker } from '../app/auth-session-expiry';

export const LogoutPage = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    clearActiveSellerGroupId();
    publishLogoutMarker();
    Auth.signOut()
      .catch(() => {})
      .finally(() => {
        navigate('/login', { replace: true });
      });
  }, [navigate]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-ab-bg p-ab-6">
      <Loader2 className="animate-spin text-ab-fg-muted" size={28} aria-hidden />
    </main>
  );
};
